import httpClient from '@/http-client'

export const user = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/users', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const seller = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/sellers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const category = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productGroup = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/product-groups', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productQuery = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const income = data => {
  return httpClient
    .post('/api/v1/reports/finances/incomes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const incomeExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/incomes/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const incomeBySale = data => {
  return httpClient
    .get('/api/v1/reports/finances/income-by-sales', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const saleItem = data => {
  return httpClient
    .post('/api/v1/reports/finances/sale-items', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const saleItemExcel = data => {
  return httpClient
    .post('/api/v1/reports/finances/sale-items/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const cashFlowAndStockControl = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/finances/daily-cash-flow-and-stocks', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  income,
  incomeBySale,
  user,
  category,
  saleItem,
  productQuery,
  cashFlowAndStockControl,
  incomeExcel,
  saleItemExcel,
  productGroup,
  seller
}
